import React, { useState } from "react";
import { useLsp } from "../store/LspContext";
import { apiInitiateUpiPayment } from "../api/lspApi";

export default function InitiateUpiPaymentPage() {
    const { state } = useLsp();
    const [amount, setAmount] = useState(1);
    const [out, setOut] = useState("");
    const [payUrl, setPayUrl] = useState("");
    const [loading, setLoading] = useState(false);

    const run = async () => {
        setLoading(true); setOut(""); setPayUrl("");
        try {
            const res = await apiInitiateUpiPayment(state.baseUrl, state.token, state.partnerLoanId, Number(amount));
            setOut(JSON.stringify(res, null, 2));
            if (res?.payment_url) setPayUrl(res.payment_url);
        } catch (e) {
            setOut("❌ " + e.message);
        } finally { setLoading(false); }
    };

    return (
        <div style={card}>
            <h2 style={h2}>11) Initiate UPI Payment</h2>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
                <input style={inp} type="number" min="1" value={amount} onChange={(e) => setAmount(e.target.value)} />
                <button style={btn} onClick={run} disabled={loading || !state.token || !state.partnerLoanId}>
                    Initiate
                </button>
            </div>

            {payUrl && (
                <div style={{ marginTop: 10 }}>
                    <a href={payUrl} target="_blank" rel="noreferrer" style={{ color: "#93c5fd" }}>
                        Open Payment URL
                    </a>
                </div>
            )}

            <pre style={pre}>{loading ? "⏳ loading..." : out || "No response yet"}</pre>
        </div>
    );
}
const card = { padding: 16, border: "1px solid #334155", borderRadius: 12, background: "#0f172a" };
const h2 = { marginTop: 0 };
const inp = { padding: 10, borderRadius: 10, border: "1px solid #334155", background: "#fffff", color: "#e5e7eb", width: 140 };
const btn = { padding: "10px 14px", borderRadius: 10, border: "1px solid #475569", background: "#1f2937", color: "#e5e7eb", cursor: "pointer" };
const pre = { marginTop: 12, background: "#fffff", border: "1px solid #334155", borderRadius: 10, padding: 12, overflow: "auto", maxHeight: 360 };
